export default () => ({
    leftColumnWidth: 384,

    resize: {
        line: null,
        hoverZone: null,
        isHovering: false,
        isResizing: false,
        lineTimeout: null,
        startX: 0,
        startWidth: 0,
        mouseMoveHandler: null,
        mouseUpHandler: null,
        windowResizeHandler: null,
        
        init(minWidth, maxWidth, onResize, onResizeEnd) {
            this.minWidth = minWidth;
            this.maxWidth = maxWidth;
            this.onResize = onResize;
            this.onResizeEnd = onResizeEnd;
            
            this.leftColumnWidth = this.calculateLeftColumnWidth();
            // Initial update
            if (this.onResize) this.onResize(this.leftColumnWidth);
            if (this.onResizeEnd) this.onResizeEnd(this.leftColumnWidth);
            
            this.windowResizeHandler = () => {
                const newWidth = this.calculateLeftColumnWidth();
                if (newWidth !== this.leftColumnWidth) {
                    this.leftColumnWidth = newWidth;
                    if (this.onResize) this.onResize(newWidth);
                    if (this.onResizeEnd) this.onResizeEnd(newWidth);
                    this.updateElements();
                }
            };
            window.addEventListener('resize', this.windowResizeHandler);
            
            this.createLine();
            this.createHoverZone();
            this.updateElements();
            
            this.mouseMoveHandler = (e) => this.handleMouseMove(e);
            this.mouseUpHandler = () => this.handleMouseUp();
            
            document.addEventListener('mousemove', this.mouseMoveHandler);
            document.addEventListener('mouseup', this.mouseUpHandler);
        },
        
        calculateLeftColumnWidth() {
            const width = window.innerWidth;
            
            if (width < 768) {
                return 192;
            }
            else if (width >= 768 && width < 1536) {
                return 384;
            }
            else {
                return 448;
            }
        },
        
        getVisibleContainer() {
            const containers = document.querySelectorAll('[data-resize-container]');
            for (let container of containers) {
                if (container.offsetParent !== null) {
                    return container;
                }
            }
            return null;
        },
        
        createLine() {
            if (this.line) return;
            
            this.line = document.createElement('div');
            this.line.style.position = 'absolute';
            this.line.style.width = '3px';
            this.line.style.backgroundColor = '#36404c';
            this.line.style.pointerEvents = 'none';
            this.line.style.zIndex = '40';
            this.line.style.transition = 'opacity 0.2s ease';
            this.line.style.opacity = '0';
            this.line.style.transformOrigin = 'center';
            
            const container = this.getVisibleContainer();
            if (container) {
                container.appendChild(this.line);
            }
        },
        
        createHoverZone() {
            if (this.hoverZone) return;
            
            this.hoverZone = document.createElement('div');
            this.hoverZone.style.position = 'absolute';
            this.hoverZone.style.width = '8px';
            this.hoverZone.style.cursor = 'col-resize';
            this.hoverZone.style.zIndex = '35';
            
            this.hoverZone.addEventListener('mouseenter', (e) => this.onHoverStart(e));
            this.hoverZone.addEventListener('mouseleave', () => this.onHoverEnd());
            this.hoverZone.addEventListener('mousedown', (e) => this.startResize(e));
            
            const container = this.getVisibleContainer();
            if (container) {
                container.appendChild(this.hoverZone);
            }
        },
        
        updateElements() {
            if (!this.hoverZone || !this.line) return;
            
            const container = this.getVisibleContainer();
            if (!container) return;
            
            const headerRow = container.querySelector('[data-resize-header]');
            // Try both possible refs for left content (view mode or customize mode)
            const leftContent = container.querySelector(`[x-ref='leftContentView']`) || 
                              container.querySelector(`[x-ref='leftContentCustomize']`) ||
                              container.querySelector(`[x-ref='leftContent']`);
            
            const headerHeight = headerRow ? headerRow.offsetHeight : 0;
            
            let contentHeight = 0;
            if (leftContent) {
                const sections = leftContent.children;
                for (let section of sections) {
                    contentHeight += section.offsetHeight;
                }
            }
            
            const totalHeight = headerHeight + contentHeight;
            const leftPosition = this.leftColumnWidth - 4;
            
            this.hoverZone.style.left = `${leftPosition}px`;
            this.hoverZone.style.top = '0px';
            this.hoverZone.style.height = `${totalHeight}px`;
            
            this.line.style.left = `${this.leftColumnWidth}px`;
        },
        
        onHoverStart(e) {
            this.isHovering = true;
            
            if (this.lineTimeout) {
                clearTimeout(this.lineTimeout);
            }
            
            const mouseEvent = { clientY: e.clientY };
            
            this.lineTimeout = setTimeout(() => {
                this.showLine(mouseEvent);
            }, 300);
        },
        
        onHoverEnd() {
            this.isHovering = false;
            
            if (this.lineTimeout) {
                clearTimeout(this.lineTimeout);
                this.lineTimeout = null;
            }
            
            this.hideLine();
        },
        
        showLine(e) {
            if (!this.line || this.isResizing) return;
            
            const container = this.getVisibleContainer();
            if (!container) return;
            
            const containerRect = container.getBoundingClientRect();
            const mouseY = e.clientY - containerRect.top;
            
            const headerRow = container.querySelector('[data-resize-header]');
            // Try both possible refs for left content (view mode or customize mode)
            const leftContent = container.querySelector(`[x-ref='leftContentView']`) || 
                              container.querySelector(`[x-ref='leftContentCustomize']`) ||
                              container.querySelector(`[x-ref='leftContent']`);
            
            const headerHeight = headerRow ? headerRow.offsetHeight : 0;
            
            let contentHeight = 0;
            if (leftContent) {
                const sections = leftContent.children;
                for (let section of sections) {
                    contentHeight += section.offsetHeight;
                }
            }
            
            const totalHeight = headerHeight + contentHeight;
            
            this.line.style.transition = 'none';
            this.line.style.top = `${mouseY}px`;
            this.line.style.height = '0px';
            this.line.style.opacity = '1';
            
            this.line.offsetHeight;
            
            this.line.style.transition = 'top 0.15s ease-out, height 0.15s ease-out';
            this.line.style.top = '0px';
            this.line.style.height = `${totalHeight}px`;
        },
        
        hideLine() {
            if (!this.line || this.isResizing) return;
            
            this.line.style.transition = 'opacity 0.2s ease';
            this.line.style.opacity = '0';
            
            setTimeout(() => {
                if (this.line && !this.isHovering && !this.isResizing) {
                    this.line.style.transition = 'none';
                    this.line.style.top = '0px';
                    this.line.style.height = '0px';
                }
            }, 200);
        },
        
        startResize(e) {
            if (this.lineTimeout) {
                clearTimeout(this.lineTimeout);
                this.lineTimeout = null;
            }
            
            if (!this.line || this.line.style.opacity === '0') {
                this.showLine({ clientY: e.clientY });
            }
            
            this.isResizing = true;
            this.startX = e.clientX;
            this.startWidth = this.leftColumnWidth;
            
            if (this.line) {
                this.line.style.opacity = '1';
            }
            
            document.body.style.userSelect = 'none';
            document.body.style.cursor = 'col-resize';
        },
        
        handleMouseMove(e) {
            if (!this.isResizing) return;
            
            const deltaX = e.clientX - this.startX;
            const newWidth = this.startWidth + deltaX;
            
            if (newWidth >= this.minWidth && newWidth <= this.maxWidth) {
                this.leftColumnWidth = newWidth;
                if (this.onResize) this.onResize(newWidth);
                this.updateElements();
            }
        },
        
        handleMouseUp() {
            if (this.isResizing) {
                this.isResizing = false;
                document.body.style.userSelect = '';
                document.body.style.cursor = '';
                
                if (this.onResizeEnd) this.onResizeEnd(this.leftColumnWidth);

                if (!this.isHovering) {
                    this.hideLine();
                } else {
                    if (this.line) {
                        this.line.style.opacity = '0';
                    }
                    
                    if (this.lineTimeout) {
                        clearTimeout(this.lineTimeout);
                    }
                    
                    this.lineTimeout = setTimeout(() => {
                        const hoverZone = this.hoverZone;
                        if (hoverZone) {
                            const rect = hoverZone.getBoundingClientRect();
                            const centerY = rect.top + (rect.height / 2);
                            this.showLine({ clientY: centerY });
                        }
                    }, 300);
                }
            }
        },
        
        cleanup() {
            if (this.lineTimeout) {
                clearTimeout(this.lineTimeout);
            }
            
            window.removeEventListener('resize', this.windowResizeHandler);
            document.removeEventListener('mousemove', this.mouseMoveHandler);
            document.removeEventListener('mouseup', this.mouseUpHandler);
            
            if (this.line && this.line.parentNode) {
                this.line.parentNode.removeChild(this.line);
            }
            if (this.hoverZone && this.hoverZone.parentNode) {
                this.hoverZone.parentNode.removeChild(this.hoverZone);
            }
        },
        
        reparentElements() {
            // Move line and hover zone to the currently visible container
            const container = this.getVisibleContainer();
            if (!container) return;
            
            if (this.line && this.line.parentNode !== container) {
                if (this.line.parentNode) {
                    this.line.parentNode.removeChild(this.line);
                }
                container.appendChild(this.line);
            }
            
            if (this.hoverZone && this.hoverZone.parentNode !== container) {
                if (this.hoverZone.parentNode) {
                    this.hoverZone.parentNode.removeChild(this.hoverZone);
                }
                container.appendChild(this.hoverZone);
            }
        }
    },
    
    initColumnResizeFeature(minWidth, maxWidth, onResize, onResizeEnd) {
        this.$nextTick(() => {
            this.resize.init(minWidth, maxWidth, onResize, onResizeEnd);
        });
    },
    
    updateResizeElements() {
        if (this.resize) {
            this.resize.leftColumnWidth = this.leftColumnWidth;
            this.resize.reparentElements();
            this.resize.updateElements();
        }
    },
    
    destroyColumnResizeFeature() {
        if (this.resize) {
            this.resize.cleanup();
        }
    }
});
